// React imports
import React from 'react';
import { useHistory } from 'react-router-dom';

// Material-UI imports
import {
  Paper,
  Button,
  CssBaseline,
  Typography,
  Container,
  Box,
} from '@material-ui/core';

// Other imports
// @ts-ignore
import { yupResolver } from '@hookform/resolvers/yup';
// @ts-ignore
import * as yup from 'yup';

// Absolute imports
import Logo from 'assets/Diligent_Equity.png';
import getVersion from 'utils/version';
import { routes } from 'routes';

// Relative imports
import useStyles from './PasswordResetLinkExpiredStyles';

export function PasswordResetLinkExpiredPage() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Paper variant="outlined" square className={`${classes.paper} lens-login-form`}>
        <img src={Logo} alt="logo" className={classes.logo} />
        <div style={{ width: '100%' }}>
          <label className={classes.inputLabel}>
            The link you are trying to reach has expired.
          </label>
          <Box display="flex" justifyContent="flex-end">
            <Button
              type="button"
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={() => history.push(routes.LOGIN)}
            >
              Back to Login
            </Button>
          </Box>
        </div>
        <div style={{ width: '100%' }}>
          <Box display="flex" justifyContent="flex-end">
            <Typography
              variant="body2"
              color="textPrimary"
              align="right"
              className={classes.version}
            >
              {getVersion()}
            </Typography>
          </Box>
        </div>
      </Paper>
    </Container>
  );
}
